export default "__VITE_ASSET__9eefacac__"